 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"accounts-listing":"accounts-listing","cardsListing~cardsListingModal~dasboard-team-my-cards~dashboard-client~templates-listing-page~templa~be8691fa":"cardsListing~cardsListingModal~dasboard-team-my-cards~dashboard-client~templates-listing-page~templa~be8691fa","cardsListing~dasboard-team-my-cards~dashboard-client":"cardsListing~dasboard-team-my-cards~dashboard-client","dasboard-team-my-cards":"dasboard-team-my-cards","dashboard-client":"dashboard-client","cardsListing":"cardsListing","templates-listing-page":"templates-listing-page","add-card":"add-card","cardsListingModal~templates-single-details-page~templates-single-edit-page":"cardsListingModal~templates-single-details-page~templates-single-edit-page","templates-single-details-page~templates-single-edit-page":"templates-single-details-page~templates-single-edit-page","templates-single-edit-page":"templates-single-edit-page","cardsListingModal":"cardsListingModal","templates-single-details-page":"templates-single-details-page","login":"login","dashboard":"dashboard","dashboard-team":"dashboard-team","network-error":"network-error","not-found":"not-found","user-profile":"user-profile"}[chunkId]||chunkId) + "." + {"accounts-listing":"0606f2d5","cardsListing~cardsListingModal~dasboard-team-my-cards~dashboard-client~templates-listing-page~templa~be8691fa":"985ecf73","cardsListing~dasboard-team-my-cards~dashboard-client":"5afbbafe","dasboard-team-my-cards":"cc22ee93","dashboard-client":"e7b44356","chunk-6b42ac47":"8634a4a1","cardsListing":"c4e2202d","templates-listing-page":"a916f16b","chunk-2d0b15bc":"9bfac58d","chunk-2d0c7b42":"07b7e637","chunk-2d0d01fa":"36c71359","chunk-2d0dd0c9":"86c95a07","chunk-4513b40a":"9e516ada","chunk-e114d35c":"9cf59753","chunk-ea3ec564":"cc74a2d1","add-card":"0f370090","cardsListingModal~templates-single-details-page~templates-single-edit-page":"882aa106","templates-single-details-page~templates-single-edit-page":"0654c566","templates-single-edit-page":"bc9c7877","cardsListingModal":"c2716972","templates-single-details-page":"0d61dfee","chunk-2c19c47e":"90b90db3","login":"38ec8d6c","dashboard":"c78b6265","dashboard-team":"23fcfe92","network-error":"55475f87","not-found":"3ca13c67","user-profile":"d41b8354","chunk-3f92833b":"4177f9d4","chunk-1c2b169c":"9f2eb79f","chunk-53c03e3d":"17394113"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"accounts-listing":1,"cardsListing~cardsListingModal~dasboard-team-my-cards~dashboard-client~templates-listing-page~templa~be8691fa":1,"cardsListing~dasboard-team-my-cards~dashboard-client":1,"dasboard-team-my-cards":1,"dashboard-client":1,"chunk-6b42ac47":1,"cardsListing":1,"templates-listing-page":1,"chunk-4513b40a":1,"chunk-e114d35c":1,"chunk-ea3ec564":1,"add-card":1,"cardsListingModal~templates-single-details-page~templates-single-edit-page":1,"templates-single-details-page~templates-single-edit-page":1,"templates-single-edit-page":1,"cardsListingModal":1,"templates-single-details-page":1,"chunk-2c19c47e":1,"login":1,"dashboard":1,"dashboard-team":1,"network-error":1,"not-found":1,"user-profile":1,"chunk-3f92833b":1,"chunk-1c2b169c":1,"chunk-53c03e3d":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"accounts-listing":"accounts-listing","cardsListing~cardsListingModal~dasboard-team-my-cards~dashboard-client~templates-listing-page~templa~be8691fa":"cardsListing~cardsListingModal~dasboard-team-my-cards~dashboard-client~templates-listing-page~templa~be8691fa","cardsListing~dasboard-team-my-cards~dashboard-client":"cardsListing~dasboard-team-my-cards~dashboard-client","dasboard-team-my-cards":"dasboard-team-my-cards","dashboard-client":"dashboard-client","cardsListing":"cardsListing","templates-listing-page":"templates-listing-page","add-card":"add-card","cardsListingModal~templates-single-details-page~templates-single-edit-page":"cardsListingModal~templates-single-details-page~templates-single-edit-page","templates-single-details-page~templates-single-edit-page":"templates-single-details-page~templates-single-edit-page","templates-single-edit-page":"templates-single-edit-page","cardsListingModal":"cardsListingModal","templates-single-details-page":"templates-single-details-page","login":"login","dashboard":"dashboard","dashboard-team":"dashboard-team","network-error":"network-error","not-found":"not-found","user-profile":"user-profile"}[chunkId]||chunkId) + "." + {"accounts-listing":"30379c68","cardsListing~cardsListingModal~dasboard-team-my-cards~dashboard-client~templates-listing-page~templa~be8691fa":"ffa841e8","cardsListing~dasboard-team-my-cards~dashboard-client":"1b0cf883","dasboard-team-my-cards":"6e010e61","dashboard-client":"d8994bb3","chunk-6b42ac47":"cf782de3","cardsListing":"52938435","templates-listing-page":"92fcc6e9","chunk-2d0b15bc":"31d6cfe0","chunk-2d0c7b42":"31d6cfe0","chunk-2d0d01fa":"31d6cfe0","chunk-2d0dd0c9":"31d6cfe0","chunk-4513b40a":"45967b2b","chunk-e114d35c":"a87719d4","chunk-ea3ec564":"20e52259","add-card":"b4969389","cardsListingModal~templates-single-details-page~templates-single-edit-page":"7ef3493b","templates-single-details-page~templates-single-edit-page":"86600bb8","templates-single-edit-page":"cfa111f5","cardsListingModal":"4ce8f637","templates-single-details-page":"4f42277d","chunk-2c19c47e":"5ef6b34d","login":"49b4e5db","dashboard":"70cc4f75","dashboard-team":"48684e73","network-error":"23dd58ff","not-found":"520eb299","user-profile":"41b3e59b","chunk-3f92833b":"ca528277","chunk-1c2b169c":"1cd495aa","chunk-53c03e3d":"67d8fbf7"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
